// TodayChallengePill — pill discreto "Desafio de hoje" na Home.
// Iter58 (Fase 2 Calendário Pastoral).
//
// Consome useDaily().desafio_do_dia. Renderiza somente quando o campo
// vem preenchido da landing. Se null/vazio → não aparece (composição
// defensiva, silêncio elegante).
//
// Regras (spec Carlos):
//  - Discreto, dourado
//  - Abaixo do card devocional
//  - Não altera Home.jsx (composição pura via slot)

import React from "react";
import { Flame } from "lucide-react";
import useDaily from "../lib/useDaily";

export default function TodayChallengePill() {
  const { daily } = useDaily();
  const desafio = (daily?.desafio_do_dia || "").trim();
  if (!desafio) return null;

  return (
    <section
      data-testid="home-daily-challenge"
      className="mt-6 rounded-2xl border border-gold/35 bg-gold/8 px-5 py-4 sm:px-6"
      style={{ background: "rgba(201, 169, 97, 0.08)" }}
    >
      <div className="flex items-start gap-3">
        <span className="w-9 h-9 rounded-full bg-gold/15 flex items-center justify-center flex-shrink-0">
          <Flame className="w-4 h-4 text-gold" />
        </span>
        <div className="flex-1 min-w-0">
          <p className="text-[10px] uppercase tracking-[0.3em] text-gold">
            Desafio de hoje
          </p>
          <p
            className="mt-1.5 text-[15px] leading-relaxed text-navy/85"
            data-testid="home-daily-challenge-text"
          >
            {desafio}
          </p>
        </div>
      </div>
    </section>
  );
}
